
export default [
  {
    path: '/',
    name: 'main',
    component: resolve => require(['../view/Main.vue'], resolve),
    children: [
      {
        path: '404',
        name: 'Page404',
        component: resolve => require(['../view/component/404.vue'], resolve)
      },
      {
        path: 'spaces',
        name: 'spaces',
        props: true,
        component: resolve => require(['../view/Space.vue'], resolve),
        children: [
          {
            path: 'nobody',
            name: 'nobody',
            component: resolve => require(['../view/component/404.vue'], resolve)
          },
          {
            path: ':id',
            name: 'users',
            component: resolve => require(['../view/component/User.vue'], resolve),
            redirect: {name: "home"},
            props: true,
            children: [
              {
                path: 'home',
                name: 'home',
                props: true,
                component: resolve => require(['../view/minMenu/Home.vue'], resolve),
              },
              {
                path: 'livesCircle',
                name: 'livesCircle',
                component: resolve => require(['../view/minMenu/LivesCircle.vue'], resolve),
              },
              {
                path: 'lives',
                name: 'lives',
                props: true,
                component: resolve => require(['../view/minMenu/Lives.vue'], resolve),
              },
              {
                path: 'album',
                name: 'album',
                props: true,
                component: resolve => require(['../view/minMenu/Album.vue'], resolve),
              },
              {
                path: 'write',
                name: 'write',
                props: true,
                component: resolve => require(['../view/minMenu/Write.vue'], resolve),
              },
              {
                path: 'write/:writeId',
                name: 'writeDetail',
                props: true,
                component: resolve => require(['../view/minMenu/second/WriteDetail.vue'], resolve)
              },
              {
                path: 'write-category-manage',
                name: 'writeCategoryManage',
                component: resolve => require(['../view/minMenu/WriteCategoryManage.vue'], resolve)
              },
              {
                path: 'dis',
                name: 'dis',
                props: true,
                component: resolve => require(['../view/minMenu/Dis.vue'], resolve),
              },
              {
                path: '*',
                name: 'spaceObj404',
                redirect: {name: "home"},
              },
            ]
          },
        ]
      },
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: resolve => require(['../view/Index.vue'], resolve)
  },
  {
    path: '/sms-login',
    name: 'smsLogin',
    component: resolve => require(['../view/Index.vue'], resolve)
  },
  {
    path: '/register',
    name: 'register',
    component: resolve => require(['../view/Index.vue'], resolve)
  },
  {
    path: '/email-register',
    name: 'emailRegister',
    component: resolve => require(['../view/Index.vue'], resolve)
  },
  {
    path: '/user/activity',
    name: 'userActivity',
    component: resolve => require(['../view/UserActivity.vue'], resolve)
  },
  {
    path: '/user/reset-password',
    name: 'userResetPassword',
    component: resolve => require(['../view/UserResetPassword.vue'], resolve)
  },
  {
    path: '/layim/chatLog',
    name: 'ChatLog',
    component: resolve => require(['../view/layim/ChatLog.vue'], resolve)
  },
  {
    path: "*",
    redirect: "/404"
  },
]



// WEBPACK FOOTER //
// ./src/router/routes-path.js